import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import "./ProvinciaCantonDistrito.css";

ProvinciaCantonDistrito.propTypes = {
  getLocality: PropTypes.func, //funcion que devuelve la localidad seleccionada. Ejemplo: getLocality(provincia,canton, distrito)
  clearLocality: PropTypes.bool,
};

function ProvinciaCantonDistrito({
  getLocality = () => {},
  clearLocality,
  ...props
}) {
  const [curProvince, setCurProvince] = useState([]);
  const [curCanton, setCurCanton] = useState([]);
  const [curDistrito, setCurDistrito] = useState([]);
  const [curCantones, setCurCantones] = useState([]);
  const [curDistritos, setCurDistritos] = useState([]);

  //Selectores de estado
  const { provincias } = useSelector(({ Base }) => Base.Catalogos);
  const { cantones } = useSelector(({ Base }) => Base.Catalogos);
  const { distritos } = useSelector(({ Base }) => Base.Catalogos);

  useEffect(() => {
    if (!isEmpty(curProvince)) {
      getLocality(curProvince, [], []);
      const curProv = curProvince[0]?.Id;
      let currentCantones = cantones.filter(
        (canton) => canton.IdProvincia === curProv
      );
      setCurCantones(currentCantones);
    } else {
      getLocality([], [], []);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curProvince]);

  useEffect(() => {
    if (!isEmpty(curCanton)) {
      getLocality(curProvince, curCanton, []);
      const curCant = curCanton[0]?.Id;
      let currentDistritos = distritos.filter(
        (distrito) => distrito.IdCanton === curCant
      );
      setCurDistritos(currentDistritos);
    } else {
      getLocality(curProvince, [], []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curCanton]);

  useEffect(() => {
    if (!isEmpty(curDistrito)) {
      getLocality(curProvince, curCanton, curDistrito);
    } else {
      getLocality(curProvince, curCanton, []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curDistrito]);

  const handleChangeProvincia = (event) => {
    const idProv = parseInt(event.target.value);
    if (idProv > 0) {
      let currentProvincia = provincias.filter((prov) => prov.Id === idProv);
      setCurProvince(currentProvincia);
      setCurCantones([]);
      setCurCanton([]);
      setCurDistritos([]);
      setCurDistrito([]);
    } else {
      setCurProvince([]);
      setCurCantones([]);
      setCurCanton([]);
      setCurDistritos([]);
      setCurDistrito([]);
    }
  };

  const handleChangeCanton = (event) => {
    const idCanton = parseInt(event.target.value);
    if (idCanton > 0) {
      let currentCanton = cantones.filter((canton) => canton.Id === idCanton);
      setCurCanton(currentCanton);
      setCurDistritos([]);
      setCurDistrito([]);
    } else {
      setCurCanton([]);
      setCurDistritos([]);
      setCurDistrito([]);
    }
  };

  const handleChangeDistrito = (event) => {
    const idDist = parseInt(event.target.value);
    if (idDist > 0) {
      let currentDistrito = distritos.filter((dist) => dist.Id === idDist);
      setCurDistrito(currentDistrito);
    } else {
      setCurDistrito([]);
    }
  };

  return (
    <div className="provcantdist-fields-arrange">
      <div className="provcantdis-grow pt-3">
        <label className="fs-5">Provincia</label>
        <select
          id="IdProvincia"
          name="IdProvincia"
          className="form-select3"
          aria-label="Seleccione una Provincia"
          onChange={(e) => handleChangeProvincia(e)}
          value={setCurProvince[0]?.Id}
        >
          <option value={0}>Seleccionar</option>
          {provincias?.map((item, index) => {
            return (
              <option key={index} value={item.Id}>
                {item.Nombre}
              </option>
            );
          })}
        </select>
      </div>
      <div className="provcantdis-grow pt-3">
        <label className="fs-5">Cantón</label>
        <select
          id="IdCanton"
          name="IdCanton"
          className="form-select3"
          aria-label="Seleccione un Cantón"
          onChange={(e) => handleChangeCanton(e)}
          value={setCurCanton[0]?.Id}
        >
          <option value={0}>Seleccionar</option>
          {curCantones.map((item, index) => {
            return (
              <option key={index} value={item.Id}>
                {item.Nombre}
              </option>
            );
          })}
        </select>
      </div>
      <div className="provcantdis-grow pt-3">
        <label className="fs-5">Distrito</label>
        <select
          id="IdDistrito"
          name="IdDistrito"
          className="form-select3"
          aria-label="Seleccione un Distrito"
          onChange={(e) => handleChangeDistrito(e)}
          value={setCurDistrito[0]?.Id}
        >
          <option value={0}>Seleccionar</option>
          {curDistritos.map((item, index) => {
            return (
              <option key={index} value={item.Id}>
                {item.Nombre}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
}

export default ProvinciaCantonDistrito;
